interface ImageDimensions {
  src: string;
  naturalWidth: number;
  naturalHeight: number;
}

/** Uses the Image constructor to obtain natural dimensions without rendering to the DOM. */
export const loadImageDimensions = (src: string): Promise<ImageDimensions> =>
  new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = () =>
      resolve({ src, naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight });
    img.onerror = () => resolve({ src, naturalWidth: 0, naturalHeight: 0 });
  });
